import { DeviceType } from "@common/components/ListDetailViews/DetailView/DeviceCard/const";
import { TabType } from "@common/components/ListDetailViews/Layout/NavigationBar/ViewsTabs/context";
import { canShowRealtimeData } from "@common/utils/devices/GraphFunctions";
import { canViewTicket, hasAuditTrailsLicense } from "@common/utils/user";
import { Account } from "@services/account/types";
import { Device } from "@services/devices/types";
import { MetaData } from "@services/monitoring/types";
import { AuthenticatedUser } from "@services/user/types";

export enum DeviceTab {
  Realtime = "Realtime",
  MapView = "Map View",
  Tickets = "Tickets",
  AggregatedDevices = "Aggregated Devices",
  AuditTrails = "Audit Trails",
}

export const isPaused = (device?: Device) => {
  if (device?.detailedStatuses) {
    return device.detailedStatuses.some(
      (item) =>
        item.pauseMonitoringStatus?.paused ||
        item.pauseMonitoringStatus?.outOfSchedule
    );
  }
  return false;
};

export const isTriggerPaused = (device?: Device) => {
  if (device?.detailedStatuses) {
    return device.detailedStatuses.some(
      (item) => item.monitoringTriggersStatus?.paused
    );
  }
  return false;
};
export const isTriggerBlocked = (device?: Device) => {
  if (device?.detailedStatuses) {
    return device.detailedStatuses.some(
      (item) => item.monitoringTriggersStatus?.blocked
    );
  }
  return false;
};
export const getSelectedTab = (
  queryStringTab: string | null,
  tabs: TabType[]
) => {
  if (queryStringTab) return queryStringTab;

  const firstEnabledTab = tabs.find((tab) => !tab.disabled);

  return firstEnabledTab?.name ?? tabs[0].name;
};

export const getDeviceTabs = (
  user: AuthenticatedUser,
  account: Account | undefined,
  device: Device,
  deviceGraphMetaData: MetaData[]
) => {
  const isManaged = device.room?.managed;
  const isAsset = device?.type === DeviceType.ASSET;
  const canShowRealtime = canShowRealtimeData(device);
  const isGraphDataEmpty = deviceGraphMetaData.length === 0;

  const isManagedNotAsset = isManaged && !isAsset;
  const hasRealtimeData =
    isManagedNotAsset && (canShowRealtime || !isGraphDataEmpty);
  const isRealtimeDataDisabled = isManagedNotAsset && !canShowRealtime;

  const isRealtimeTabDisabled = !hasRealtimeData && isRealtimeDataDisabled;
  const isRealtimeTabHidden = !hasRealtimeData && !isRealtimeDataDisabled;

  const tabs: TabType[] = [
    {
      name: DeviceTab.Realtime,
      hidden: isRealtimeTabHidden,
      disabled: isRealtimeTabDisabled,
      tooltip: isRealtimeTabDisabled ? "No realtime data available" : undefined,
    },
    { name: DeviceTab.MapView },
    { name: DeviceTab.Tickets, disabled: !canViewTicket(user) },
    { name: DeviceTab.AggregatedDevices, hidden: !device.isAggregator },
    { name: DeviceTab.AuditTrails, hidden: !hasAuditTrailsLicense(account) },
  ];

  return tabs.filter((tab) => !tab.hidden);
};
